module.exports = "<update-activestatus></update-activestatus>\n<!-- <status-response></status-response> -->"